if (!customElements.get('hotspot-section')) {
  class HotspotSection extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
      this.boundOnKeydown = this.onKeydown.bind(this);
      document.addEventListener('keydown', this.boundOnKeydown);

      // Cards sit in the DOM at rest as visibility:hidden (not display:none)
      // so they can fade in without a layout jump. Left at their raw
      // centered position, a card next to an edge pin extends past the
      // viewport even while hidden, which some browsers (Safari included)
      // count toward the page's scrollable width — a phantom horizontal
      // scrollbar. Clamp every card up front, same as openPin() does right
      // before reveal, so the resting geometry never escapes the viewport.
      this.querySelectorAll('.hotspot__pin').forEach((pin) => this.positionCard(pin));
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.boundOnKeydown);
    }

    onClick(event) {
      const dot = event.target.closest('.hotspot__dot');

      if (dot) {
        const pin = dot.closest('.hotspot__pin');
        const wasActive = pin.classList.contains('is-active');
        this.closeAll();
        if (!wasActive) {
          this.openPin(pin, dot);
        }
        return;
      }

      if (!event.target.closest('.hotspot__card')) {
        this.closeAll();
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.closeAll();
      }
    }

    openPin(pin, dot) {
      // Position before revealing so the popover never visibly slides
      // from its default spot to its clamped/flipped position.
      this.positionCard(pin);
      pin.classList.add('is-active');
      dot.setAttribute('aria-expanded', 'true');
    }

    positionCard(pin) {
      const card = pin.querySelector('.hotspot__card');
      if (!card) return;

      const margin = 12;

      pin.classList.remove('hotspot__pin--flip-bottom');
      card.style.setProperty('--hotspot-card-shift-x', '0px');

      const viewportWidth = document.documentElement.clientWidth;

      if (card.getBoundingClientRect().top < margin) {
        pin.classList.add('hotspot__pin--flip-bottom');
      }

      const cardRect = card.getBoundingClientRect();
      let shiftX = 0;
      if (cardRect.left < margin) {
        shiftX = margin - cardRect.left;
      } else if (cardRect.right > viewportWidth - margin) {
        shiftX = viewportWidth - margin - cardRect.right;
      }
      card.style.setProperty('--hotspot-card-shift-x', `${shiftX}px`);
    }

    closeAll() {
      // Only toggle is-active here (it drives the opacity/visibility fade).
      // Leave the flip/shift state alone — clearing it would instantly snap
      // the still-fading-out card to a different spot. positionCard() always
      // recalculates it fresh before the next open, so nothing is lost.
      this.querySelectorAll('.hotspot__pin.is-active').forEach((pin) => {
        pin.classList.remove('is-active');
        pin.querySelector('.hotspot__dot')?.setAttribute('aria-expanded', 'false');
      });
    }
  }

  customElements.define('hotspot-section', HotspotSection);
}
